export const { REACT_APP_API_BASE: API_BASE } = process.env;
export const { REACT_APP_API_IMAGE_BASE: UPLOAD_URL } = process.env;
export const { REACT_APP_APIKEY: API_KEY } = process.env;
export const { REACT_APP_AUTHDOMAIN: AUTH_DOMAIN } = process.env;
export const { REACT_APP_PROJECT_ID: PROJECT_ID } = process.env;
export const { REACT_APP_STORAGEBUCKET: STORAGE_BUCKET } = process.env;
export const { REACT_APP_MESSAGING_SENDING_ID: MESSAGINGID } = process.env;
export const { REACT_APP_APPID: APPID } = process.env;
export const { REACT_APP_VAPIDKEY: VAPIDKEY } = process.env;
export const { REACT_APP_MEASURMENTID: MEASURMENTID } = process.env;
export const { REACT_APP_IMAGE_BASE_URL_LOCAL: IMAGE_BASE_URL_LOCAL } =
  process.env;
export const { REACT_APP_RECAPTCHA_SITE_KEY: RECAPTCHA_SITE_KEY } =
  process.env;

const API_V2_PREFIX = "/v2"; // all REST endpoints except healthcheck/static files

/** Prefix API paths with /v2. Leaves already-versioned and absolute URLs alone. */
export const toV2ApiPath = (path = "") => {
  if (!path || /^https?:\/\//i.test(path)) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (normalized.startsWith(`${API_V2_PREFIX}/`)) return normalized;
  if (normalized.startsWith("/v1/")) {
    return `${API_V2_PREFIX}${normalized.slice(3)}`;
  }
  return `${API_V2_PREFIX}${normalized}`;
};

export const API_LOGIN = "/v2/admin/charity/charity-login";

export const API_LOGOUT = "/v2/common/commonLogOut";

export const API_SUPER_ADMIN_LOGIN = "/v2/admin-login/login";

export const API_REFRESH_TOKEN = "/v2/common/refreshToken";

export const API_META = "/v2/auth/metaData";

export const API_CAUSE = "/v2/admin/cause/getAll";

export const API_CATEGORY = "/v2/admin/charity-category/getAll";

export const API_CHARITY_LISTING = "/v2/admin/charity/getAll";

export const API_CHARITY_LISTING_ACCEPT = "/v2/admin/charity/charityList";

export const API_VERIFY_EMAIL = "/v2/admin/charity/sentMailToUser";

export const API_CHARITY_DETAIL = "/v2/admin/charity/get/";

export const API_CHARITY_VERIFICTAION = "/v2/admin/charity/changeVerification";

//images
export const API_IMAGE_UPLOAD = "/v2/local-image/uploadImage";
export const API_IMAGE_DELETE = "/v2/local-image/removeImage";

//videos
export const API_VIDEO_UPLOAD = "/v2/local-image/uploadVideo";
export const API_VIDEO_DELETE = "/v2/local-image/removeVideo";

export const API_CHARITY_REGISTRATION = "/v2/admin/charity/create";

//common
export const API_COUNTRY = "/v2/common/getAllCountry";
export const API_STATE = "/v2/common/getAllState";
export const API_CITY = "/v2/common/getAllCities";

// Admin Cause
export const API_CAUSE_CREATE = "/v2/admin/cause/create";
export const API_CAUSE_GETALL = "/v2/admin/cause/getAll";
export const API_CAUSE_DELETE_ID = "/v2/admin/cause/delete";
export const API_CAUSE_GET_ID = "/v2/admin/cause/get/";
export const API_CAUSE_UPDATE_ID = "/v2/admin/cause/update/";

// Charity Category

export const API_CHARITY_CATEGORY_CREATE = "/v2/admin/charity-category/create";
export const API_CHARITY_CATEGORY_GETALL = "/v2/admin/charity-category/getAll";
export const API_CHARITY_CATEGORY_GET_ID = "/v2/admin/charity-category/get/";
export const API_CHARITY_CATEGORY_DELETE_ID = "/v2/admin/charity-category/delete";
export const API_CHARITY_CATEGORY_UPDATE_ID =
  "/v2/admin/charity-category/update/";

export const API_HOMEPAGE_UPDATE = "/v2/admin/homepage/updateHomepage";
export const API_HOMEPAGE_DETAIL = "/v2/admin/homepage/getHomepageDetails";

// password changes
export const API_CHANGE_PASSWORD = "/v2/admin/charity/changePassword";
export const API_FORGOT_PASSWORD = "/v2/admin/charity/forgotPassword";
export const API_RESET_PASSWORD = "/v2/admin/charity/resetPassword";

//community
export const API_COMMUNITY_LIST = "/v2/community/getCommunityList/";
export const API_COMMUNITY_CREAT = "/v2/community";
export const API_COMMUNITY_DETAIL = "/v2/community/getCommunityDetail/";
export const API_COMMUNITY_DELETE = "/v2/community/";
export const API_COMMUNITY_EDIT = "/v2/community";
export const API_COMMUNITY_HIDE = "/v2/admin/admin-community/hideCommunity/";

//Edit chairty profile view
export const API_EDIT_CHARITY_VIEW = "/v2/admin/charity/update/";

//Event
export const API_EVENT_LIST = "/v2/admin/event/eventList/";
export const API_EVENT_ADD = "/v2/admin/event/addEvent";
export const API_EVENT_DETAILS = "/v2/admin/event/findEvent/";
export const API_EVENT_UPDATE = "/v2/admin/event/editEvent/";
export const API_EVENT_DELETED = "/v2/admin/event/deleteEvent/";
export const API_EVENT_MEMBER_LIST = "/v2/event/eventDetailsExport/";
export const API_EVENT_MEMEBER_DELETE = "/v2/event/removeMember";
export const API_STRATEGIC_EVENT_LIST = "/v2/admin/event/listStrategicPartner/";

// Post
export const API_POST_ADD = "/v2/posts";
export const API_POST_List = "/v2/posts/getAllCommunityPostList/";
export const API_POST_UPATE = "/v2/posts/";
export const API_POST_DELETE = "/v2/posts/";
export const API_POST_HIDE = "/v2/posts/hidePost";
export const API_POST_LIKE_UNLIKE = "/v2/posts/likeUnlikePost/";
export const API_POST_COMMENT = "/v2/posts/postComment";
export const API_POST_COMMENT_REPLY = "/v2/posts/postCommentRply";
export const API_POST_COMMENT_LIST = "/v2/posts/getPostCommnetList/";
export const API_POST_COMMENT_LIKE = "/v2/posts/likeUnlikeComment/";

//Payment
export const API_PAYMENT_DETAIL_ADD =
  "/v2/admin/payment-method/addPaymentmethod";
export const API_PAYMENT_DETAIL_GET =
  "/v2/admin/payment-method/findPaymentMethodbyCharity/";
export const API_PAYMENT_DETAIL_UPDATE =
  "/v2/admin/payment-method/updatePaymentmethod";

//Transaction
export const API_TRANSCATION_LIST = "/v2/admin/transaction/transactionList";
export const API_TRANSCATION_LIST_EXCEL =
  "/v2/admin/transaction/charityTransactionList-excel/";
export const API_TRANSCATION_DETAIL_PDF =
  "/v2/payment/generateTransactionReciept";
export const API_COMMUNITY_TRANSCTION_LIST =
  "/v2/charityPanel/communityPayment-list";
export const API_COMMUNITY_TRANSCTION_EXCELL_DOWNLOAD =
  "/v2/admin/transaction/communityTransactionList-excel/";

//Content Mangement
export const API_CONTACT_ADD = "/v2/ContactUs/create";
export const API_GET_CMS_LIST = "/v2/admin/cms-pages/cmsPagesList";
export const API_FAQ_CATEGORY_LIST =
  "/v2/admin/admin-faq-category/faqCategoryList";
export const API_FAQ_LIST = "/v2/admin/admin-faq/faqList";

// Dashboard
export const API_CHARITY_DASHBOARD = "/v2/admin/charity/dashboard";
export const API_CHARITY_DASHBOARD_YEARGRAPH = "/v2/admin/charity/yearGraph";
export const API_CHARITY_DASHBOARD_DAYGRAPH = "/v2/admin/charity/dayGraph";
export const API_CHARITY_DASHBOARD_DAILYUPDATE =
  "/v2/admin/charity/dailyUpdates";
export const API_CHARITY_SIX_MONTH_DASHBOARD_ =
  "/v2/admin/charity/previousSixMonths";

export const API_SUBSCRIBE_DONOR_LIST = "/v2/charityPanel/subscription-list";
export const API_SUBSCRIBE_ONETIMEDONOR_LIST =
  "/v2/charityPanel/oneTimePayment-list";

// Notifiction
export const API_NTIFICTION_DELETE = "/v2/notification/";
export const API_NOTIFICTION_LIST = "/v2/notification/list";
export const API_DISMISS_ALL_NOTIFICTION = "/v2/notification/dismissAll";
//---------------Strategic---------------------

//---------------Strategic Panel---------------------

// Register
export const API_STRATEGIC_CREATE = "/v2/strategic-partner/create";

//Login
export const API_STRATEGIC_PARTNER_LOGIN = "/v2/strategic-partner/login";

//Change and Reset Password
export const API_STRATEGIC_CHANGE_PASSWORD =
  "/v2/strategic-partner/changePassword";
export const API_STRATEGIC_FORGOT_PASSWORD = "/v2/strategic-partner/forgot";
export const API_STRATEGIC_RESET_PASSWORD =
  "/v2/strategic-partner/resetPassword";

//Employee
export const API_STRATEGIC_CREATE_EMPLOYEE =
  "/v2/admin/employee/sentMailToReqEmployee";
export const API_STRATEGIC_EMPLOYEE_VERIFICATION =
  "/v2/admin/employee/EmployeeVerification";
export const API_STRATEGIC_PENDING_EMPLOYEE =
  "/v2/admin/employee/pendingEmployeeList";
export const API_STRATEGIC_APPROVE_EMPLOYEE =
  "/v2/admin/employee/approveEmployeeList";
export const API_STRATEGIC_DELETE_EMPLOYEE =
  "/v2/admin/employee/deleteEmployee/";
export const API_EMPLOYEE = "/v2/users/userDetails/";
//Strategic Partner Profile
export const API_STRATEGIC_USER_VIEW = "/v2/strategic-partner/get/";
export const API_STRATEGIC_USER_UPDATE = "/v2/strategic-partner/update/";

//Strategic Partner Post List
export const API_STRATEGIC_POST_LIST = "/v2/posts/employeePost/";
export const API_EMPLOYEE_POST_LIST = "/v2/posts/getAllUserPostList/";

//Strategic Dashboard
export const API_STRATEGIC_DASHBOARD = "/v2/admin/stategic-Partner/dashboard";
export const API_STRATEGIC_DAYGRAPH_DASHBOARD =
  "/v2/admin/stategic-Partner/dayGraphDashboard";
export const API_STRATEGIC_YEARGRAPH_DASHBOARD =
  "/v2/admin/stategic-Partner/yearGraphDashboard";
export const API_STRATEGIC_SIX_MONTH_DASHBORD =
  "/v2/admin/stategic-Partner/previousSixMonths";
//Strategic Transction
export const API_STRATEGIC_TRANSCATION_LIST =
  "/v2/admin/transaction/transactionList";
export const API_TRANSCATION_DETAIL = "/v2/admin/transaction/get/";
export const API_STRATEGIC_TRANSCATION_LIST_EXCEL =
  "/v2/admin/transaction/strategicExcelTransactionList-excel/";

//chat
export const API_CLEARE_CHAT_HISTORY = "/v2/chat/clearChatHistory/";
export const API_CHAT_CREATE_ROOM = "/v2/chat/createRoom";
